/* eslint-disable no-shadow */
import { Typography } from '@material-ui/core';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import clsx from 'clsx';
import { FC, MouseEvent } from 'react';
import { ReactComponent as Subtract } from '../../../../Asset/svg/subtract.svg';
import { ReactComponent as Subchapter } from '../../../../Asset/svg/sub_chapter.svg';
import style from './style';

interface IItemPage {
  id: string;
  title: string;
  isSelected?: boolean;
  handleClick?: () => void;
  isSubChapter?: boolean;
  hasSubChapters?: boolean;
  isExpanded?: boolean;
  onToggleExpand?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const ItemChapter: FC<IItemPage> = ({
  id,
  title,
  isSelected,
  handleClick,
  isSubChapter = false,
  hasSubChapters = false,
  isExpanded = true,
  onToggleExpand,
}) => {
  const classes = style();
  return (
    <div
      onClick={handleClick}
      className={`${classes.container} ${
        isSelected ? classes.borderSelected : classes.borderTransparent
      } `}
      style={{ paddingTop: 7, paddingBottom: 7 }}>
      <div className={classes.container2}>
        <div
          className={classes.container3}
          style={isSubChapter ? { background: 'transparent', padding: 0 } : {}}>
          {isSubChapter ? (
            <Subchapter style={{ width: 40, height: 5 }} />
          ) : (
            <Subtract style={{ width: 20, height: 20 }} />
          )}
        </div>
      </div>
      <Typography variant="h4" className={classes.title} style={isSubChapter ? { fontSize: 11 } : {}}>
        {title}
      </Typography>
      {hasSubChapters && (
        <button
          type="button"
          className={classes.chevronButton}
          aria-label={isExpanded ? 'Masquer les sous-titres' : 'Afficher les sous-titres'}
          aria-expanded={isExpanded}
          onClick={event => {
            event.stopPropagation();
            onToggleExpand?.(event);
          }}>
          <KeyboardArrowDown
            className={clsx(classes.chevron, { [classes.chevronExpanded]: isExpanded })}
          />
        </button>
      )}
    </div>
  );
};

export default ItemChapter;
